import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore, UserRole } from '../../stores/authStore';

interface DataTransferRouteProps {
  children: React.ReactNode;
}

const DataTransferRoute: React.FC<DataTransferRouteProps> = ({ children }) => {
  const { user } = useAuthStore();

  // Check if user has access to Data Transfer page
  // Only Monitor Manager (USER), Admin, and Super Admin can access
  const hasDataTransferAccess = user && (
    user.role === UserRole.USER ||
    user.role === UserRole.ADMIN ||
    user.role === UserRole.SUPER_ADMIN
  );

  if (!hasDataTransferAccess) {
    // Redirect to dashboard if user doesn't have data transfer access
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default DataTransferRoute;

